import Events from "../utils/Events.js";
import NuCalBaseView from "./NuCalBaseView.js";

/**
 * @extends NuCalBaseView
 * @param {Object} props properties.
 * @param {String} props.namespace The namespace in which this object should subscribe and publish events on.
 * @param {HTMLElement} props.view The HTML Element in which this object should render the output too.
 * @param {String} props.dateType Which date the object is dealing with. Can be "arrival", "departure" or "both". Default is "both".
 * @param {String} props.locale Language code. Default "en-US."
 * @param {String} props.UUID Unique Identifier. the default is randomly generated.
 */

export default class NuCalSelectView extends NuCalBaseView {

	constructor(props){
		super(props);
		this.classPrefix = props.classPrefix || "cp-nuCalSelectView";
		this.view.classList.add(`${this.classPrefix}`);
		const lexi = (this.dateType == 'arrival')? this.lexicon.NuCalSelectView.arrival : this.lexicon.NuCalSelectView.departure;
		this.view.innerHTML = `
            <fieldset>
                <label for="${this.classPrefix}-${this.dateType}-daySelect">${lexi.dayLabel}</label>
                <select id="${this.classPrefix}-${this.dateType}-daySelect" aria-label="${lexi.daySelectAria}" class="${this.classPrefix}-daySelect"></select>
            </fieldset>
            <fieldset>
                <label for="${this.classPrefix}-${this.dateType}-monthSelect">${lexi.monthLabel}</label>
                <select id="${this.classPrefix}-${this.dateType}-monthSelect" aria-label="${lexi.monthSelectAria}" class="${this.classPrefix}-monthSelect"></select>
            </fieldset>
            <fieldset>
                <label for="${this.classPrefix}-${this.dateType}-yearSelect">${lexi.yearLabel}</label>
                <select id="${this.classPrefix}-${this.dateType}-yearSelect" aria-label="${lexi.yearSelectAria}" class="${this.classPrefix}-yearSelect"></select>
            </fieldset>
        `;

		this._yearSelect = this.view.querySelector(`.${this.classPrefix}-yearSelect`);
		this._monthSelect = this.view.querySelector(`.${this.classPrefix}-monthSelect`);
		this._daySelect = this.view.querySelector(`.${this.classPrefix}-daySelect`);
        
		const selectDateChange = e => {
			e.preventDefault();
			const daysInMonth = new Date(this._yearSelect.value, parseInt(this._monthSelect.value) + 1, 0).getDate();
			this.date = new Date(this._yearSelect.value,this._monthSelect.value,Math.min(this._daySelect.value,daysInMonth));
			const dateChangeEvent = (this.dateType === "arrival")? this._events.updateArrivalDate : this._events.updateDepartureDate;
			Events.publish(dateChangeEvent,{ "date": this.date });
		};

		this._daySelect.addEventListener("change", selectDateChange);
		this._monthSelect.addEventListener("change", selectDateChange);
		this._yearSelect.addEventListener("change", selectDateChange);
        
	}

	subscribe(){
		this._subscriptions.push(
			Events.subscribe( this._events.datesUpdated ,this.render.bind(this) )
		);
	}

	render(props){
		this.date;

		if(this.dateType === "arrival"){
			this.date = props.arrivalDate;
			this.minDate = (props.minArrivalDate !== null)? new Date(props.minArrivalDate.valueOf()) : null;
			this.maxDate = (props.maxArrivalDate !== null)? new Date(props.maxArrivalDate.valueOf()) : null;
		}else{
			this.date = props.departureDate;
			this.minDate = (props.minDepartureDate !== null)? new Date(props.minDepartureDate.valueOf()) : null;
			this.maxDate = (props.maxDepartureDate !== null)? new Date(props.maxDepartureDate.valueOf()) : null;
		}

		/*
            BUILD ACCESSIBLE SELECT BOXES
        */
		let playDate; //this is for playing with and getting formatting from.
		playDate = new Date();

		//populate year select
		this._yearSelect.innerHTML = "";
		for(let i = this.minDate.getFullYear(); i <= this.maxDate.getFullYear(); i++){
			playDate.setFullYear(i);
			const option = document.createElement("option");
			option.value = i;
			option.innerHTML = playDate.toLocaleDateString(this.locale,{ year: "numeric" });
			this._yearSelect.add(option);
			if(this.date.getFullYear() === i) option.selected = true;
		}

		//populate month select
		this._monthSelect.innerHTML = "";
		let maxMonth = (this.date.getFullYear() === this.maxDate.getFullYear())? this.maxDate.getMonth() + 1 : 12;
		let minMonth = (this.date.getFullYear() === this.minDate.getFullYear())? this.minDate.getMonth() : 0; 
		for(let x = minMonth; x < maxMonth ; x++){
			playDate.setDate(1);
			playDate.setMonth(x);
			const option = document.createElement("option");
			option.value = x;
			option.innerHTML = playDate.toLocaleDateString(this.locale,{ month: "long" });
			this._monthSelect.add(option);
			if(this.date.getMonth() === x) option.selected = true;
		}

		//populate date select
		playDate = new Date();
		playDate.setHours(0,0,0,0);
		playDate.setMonth(this.date.getMonth());
		this._daySelect.innerHTML = "";
		let maxDay = (this.date.getFullYear() === this.maxDate.getFullYear() && this.date.getMonth() === this.maxDate.getMonth() )? this.maxDate.getDate() : new Date(this.date.getFullYear(), this.date.getMonth()+1, 0).getDate();
		let minDay = (this.date.getFullYear() === this.minDate.getFullYear() && this.date.getMonth() === this.minDate.getMonth() )? this.minDate.getDate () : 1;
		for(let x = minDay; x <= maxDay ; x++){
			playDate.setDate(x);
			const option = document.createElement("option");
			option.value = x;
			option.innerHTML = playDate.toLocaleDateString(this.locale,{ "day": "2-digit" });
			this._daySelect.add(option);
			if(this.date.getDate() === x) option.selected = true;
		}
	}

}